import React,{ useEffect, useState, useRef, useMemo } from 'react';
import LayoutWrapper from '@iso/components/utility/layoutWrapper.js';
import PageHeader from '@iso/components/utility/pageHeader';
import IntlMessages from '@iso/components/utility/intlMessages';
import { Button, Alert, Checkbox, Row, Col, Form, message, Card } from 'antd';
import FormPage from './Form.styles';
import queryString from 'query-string';
import { userFormService, formService, userService, attachment } from '@iso/services';
import _ from 'lodash';
import { visitorTypes } from '@iso/constants/visitorTypes';
import * as Survey from "survey-react";
import "survey-react/survey.css";
import "survey-react/modern.css";
import SignatureCanvas from 'react-signature-canvas';
import FinalScreen from './FinalScreen';
import FormBuilder from 'antd-form-builder';
import GlobalForm from './GlobalForm';
import { useSelector } from 'react-redux';
import BioForm from '@iso/containers/Pages/AdminPages/FormBuilder/BioForm/BioForm';
import CheckinForm from '@iso/containers/Pages/AdminPages/FormBuilder/CheckinForm/CheckinForm';
import HazardForm from '@iso/containers/Pages/AdminPages/FormBuilder/HazardForm/HazardForm';
import TrainingForm from '@iso/containers/Pages/AdminPages/FormBuilder/TrainingForm/TrainingForm';
import IllnessForm from '@iso/containers/Pages/AdminPages/FormBuilder/IllnessForm/IllnessForm';
import NearMissForm from '@iso/containers/Pages/AdminPages/FormBuilder/NearMissForm/NearMissForm';
import SchemaFormRenderer from '@iso/components/SchemaFormRenderer';
import { withCheckinInfoStep, liftCheckinInfo } from '@iso/containers/Pages/VisitorForm/checkinInfoStep';
import { element } from 'prop-types';

Survey.StylesManager.applyTheme("modern");

const FormSubmission = () => {
	const activePropertyId = useSelector((state) => state.property.activePropertyId);
	const padRef = useRef({});
	const token = queryString.parse(window.location.search).token || '';
	const [form, setForm] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');
	const [surveyContent, setSurveyContent] = useState({});
	const [questionList, setQuestionList] = useState([]);
	const [loading, setLoading] = useState(false);
	const [propertyUsers, setPropertyUsers] = useState([]);
	const [pdfForm] = Form.useForm();
	const [showFinalScreen, setShowFinalScreen] = useState(false)
	const formRef = React.createRef()
	const [globalForm] = Form.useForm()
	const uploadedFilesRef = useRef({});

  	const checkFormSubmission = (token) => {
  		userFormService.checkFormSubmission(token).then(res => {
            if(res.code === '0000')
            {
				const preSubmitData = {};

        // `answer_list` is absent when the user hasn't submitted this form yet — guard
        // it so we don't crash before setForm() and blank the whole page.
        if (res.user_form?.answer_list?.length > 0) {
          res.user_form.answer_list[res.user_form.answer_list.length - 1].forEach(answer => {
						if (answer.question_name) {
							preSubmitData[answer.question_name] = answer.answer_content;
						}
					});
				}

            	setForm(res.form);
              	let questions = [];
				if (res.form.meta_data?.visitor_types?.length > 0) {
					// Convert visitor types from snake_case to display labels with value mapping
					const visitorTypeChoices = res.form.meta_data.visitor_types.map(type => {
						const foundType = visitorTypes.find(vt => vt.value === type);
						return foundType ? { value: type, text: foundType.label } : { value: type, text: type };
					});
					
					questions.push({
						name: "visitor",
						questions: [
							{
								type: "radiogroup",
								choices: visitorTypeChoices,
								isRequired: true,
								name: "visitor_type",
								questionId: null,
								title: "Visitor Type"
							}
						]
					})
				}

				if (res.form.meta_data?.is_hosts_enabled) {
					questions.push({
						name: "host",
						questions: [
							{
								type: "dropdown",
								choices: propertyUsers.map(user => user.name),
								name: "host_name",
								title: "Host",
								questionId: null,
								requiredIf: "{visitor_type} anyof [" + res.form.meta_data?.required_visitor_types_for_hosts.join(',') + "]"
							}
						]
					})
				}
				Survey.Serializer.addProperty("question", {
					name: "question_type",
					category: "general",
					default: "",
					visible: true
				});
        if (!Survey.Serializer.findProperty("question", "question_type")) {
          Survey.Serializer.addProperty("question", { name: "question_type", category: "general", default: "", visible: true });
        }
        // question_visibility gates by visitor type; only meaningful when the form collects
        // a visitor type. Otherwise {visitor_type} is undefined and would hide every question.
        const hasVisitorTypes = res.form?.meta_data?.visitor_types?.length > 0;
        _.forEach(res.form.surveyQuestions, (question, index) => {    
				const meta = question.meta_data;
				const visibilityList = Array.isArray(meta?.question_visibility) ? meta?.question_visibility : [];
				const hasVisibility = visibilityList.length > 0;
				const visilibity = hasVisibility ? visibilityList.join(',') : [];

				const isRequired = meta?.response_required ?? true;

				const defaultValue = meta?.prefill_response
					? (preSubmitData[question.id.toString()] ?? null)
					: null;

        const isVisible = (hasVisibility && hasVisitorTypes)
					? "{visitor_type} anyof [" + visilibity + "]"
					: true;
				
	            switch(question.question_type){
					
					case 'yes/no':

						var data = {
						  name: "page_" + question.id,
						  questions: [
							{
							  type: "radiogroup",
							  choices: ["Yes", "No"],
							  isRequired: isRequired,
							  name: question.id.toString(),
							  title: question.title,
							  defaultValue: defaultValue,
							  visibleIf: isVisible,
							  question_type: question.question_type,
							}
						  ]
						};
						break;
					case 'text':
						var data = {
						  name: "page_" + question.id,
						  questions: [
							{
							  type: "text",
							  isRequired: isRequired,
							  name: question.id.toString(),
							  title: question.title,
							  defaultValue: defaultValue,
							  visibleIf: isVisible,
							  question_type: question.question_type,
							}
						  ]
						};
						break;
					case 'multiple_choice':
						var data = {
						  name: "page_" + question.id,
						  questions: [
							{
							  type: "radiogroup",
							  choices: question.meta_data.options,
							  isRequired: isRequired,
							  name: question.id.toString(),
							  title: question.title,
							  defaultValue: defaultValue,
							  visibleIf: isVisible,
							  question_type: question.question_type,
							}
						  ]
						};
						break;
					case 'signature':
						var data = {
						  name: "page_" + question.id,
						  questions: [
							{
							  type: "signaturepad",
							  isRequired: isRequired,
							  name: question.id.toString(),
							  title: question.title,
							  defaultValue: defaultValue,
							  visibleIf: isVisible,
							  question_type: question.question_type
							}
						  ]
						};
						break;
					case 'multi_selection':
						var data = {
						  name: "page_" + question.id,
						  questions: [
							{
							  type: "checkbox",
							  choices: question.meta_data.options,
							  isRequired: isRequired,
							  name: question.id.toString(),
							  title: question.title,
							//   defaultValue: defaultValue,
							  visibleIf: isVisible,
							  question_type: question.question_type
							}
						  ]
						};
						break;
					case 'number':
						var data = {
						  name: "page_" + question.id,
						  questions: [
							{
							  type: "text",
							  inputType: "number",
							  isRequired: isRequired,
							  name: question.id.toString(),
							  title: question.title,
							  defaultValue: defaultValue,
							  visibleIf: isVisible,
							  question_type: question.question_type
							}
						  ]
						};
						break;
					case 'fixed_text':
						var data = {
							name: "page_" + question.id,
							questions: [
								{
									name: question.id.toString(),
									title: question.title,
									type: "html",
									html: question.meta_data.text,
									question_type: question.question_type
								}
							]
						};
						break;
					case 'fixed_image':
						if (question.meta_data.image_id) {
							var data = {
								name: "page_" + question.id,
								questions: [
									{
										type: "image",
										title: question.title,
										name: question.id.toString(),
										imageLink: question.meta_data.image.full_path,
										question_type: question.question_type
									}
								]
							};
						}
						break;
					case 'scale':
						var data = {
						  name: "page_" + question.id,
						  questions: [
							{
							  type: "radiogroup",
							  choices: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"],
							  isRequired: isRequired,
							  name: question.id.toString(),
							  title: question.title,
							  defaultValue: defaultValue,
							  visibleIf: isVisible,
							  question_type: question.question_type
							}
						  ]
						};
						break;
					case 'upload_file':
						var data = {
							name: "page_" + question.id,
							questions: [
								{
									type: "file",
									isRequired: isRequired,
									name: question.id.toString(),
									title: question.title,
									storeDataAsText: false,
      								waitForUpload: true,
									question_type: question.question_type
								}
							]
						};
						break;
					default:
						var data = {
						  name: "page_" + question.id,
						  questions: [
							{
							  type: "comment",
							  isRequired: isRequired,
							  name: question.id.toString(),
							  title: question.title,
							  question_type: question.question_type
							}
						  ]
						};
						break;
	            }

          // Some cases only set `data` conditionally (e.g. fixed_image needs an
          // image_id). Never push an undefined page — it corrupts the survey model
          // and crashes downstream (reading 'questions' on an undefined page).
          if (data) {
            questions.push(data);
          }
        });
        setQuestionList(questions);
      } else {
        setErrorMsg(res.message);
      }
    });
  };
  
  	useEffect(() => {
		if(activePropertyId){
			userService.getUserForProperty(activePropertyId).then(res => {
				if (res.code === '0000') {
					setPropertyUsers(res.users);
				} else {
					setPropertyUsers([]);
				}
			});
		}
	}, [activePropertyId, token]);

	useEffect(() => {
		checkFormSubmission(token);
	}, [propertyUsers]);

    useEffect(() => {
	    if(questionList && form)
	    {
	      var surveyJSON = {
	        title: form.survey_title,
	        description: form.survey_description,
	        completedHtml: "<h3>Thank you for completing the survey!</h3>",
	        showCompletedPage: false,
			pages: questionList
	    }

      	setSurveyContent(surveyJSON);
    } 
  }, [questionList, form]);

	const submitSurveyData = (survey) => {
		const surveyData = survey.data;

		const formattedResults = survey.getAllQuestions().map(question => {
			const rawAnswer = surveyData[question.name];
			let answerContent = rawAnswer ?? '';

			if (question.question_type === 'upload_file') {
				const storedFiles = uploadedFilesRef.current[question.name];
				const files = Array.isArray(storedFiles) && storedFiles.length > 0
					? storedFiles
					: Array.isArray(rawAnswer)
						? rawAnswer
						: [];
				const uniqueFiles = [];
				const seenKeys = new Set();

				files.forEach(fileItem => {
					const key =
						fileItem?.attachment_id
						?? fileItem?.attachmentId
						?? fileItem?.content
						?? fileItem?.file?.content
						?? fileItem?.url
						?? fileItem?.file?.name
						?? fileItem?.name;

					if (!key || !seenKeys.has(key)) {
						if (key) {
							seenKeys.add(key);
						}
						uniqueFiles.push(fileItem);
					}
				});

				const metaList = Array.isArray(storedFiles) ? storedFiles : [];
				const metaById = new Map();
				const metaByUrl = new Map();
				const metaByName = new Map();

				metaList.forEach(metaItem => {
					if (!metaItem || typeof metaItem !== 'object') {
						return;
					}
					const metaId = metaItem?.attachment_id ?? metaItem?.attachmentId ?? null;
					if (metaId) {
						metaById.set(String(metaId), metaItem);
					}
					const metaUrl = metaItem?.url ?? metaItem?.storage_path ?? null;
					if (metaUrl) {
						metaByUrl.set(metaUrl, metaItem);
					}
					const metaName = metaItem?.name ?? null;
					if (metaName) {
						metaByName.set(metaName, metaItem);
					}
				});

				answerContent = uniqueFiles.map(fileItem => {
					const rawId = fileItem?.attachment_id
						?? fileItem?.attachmentId
						?? fileItem?.attachment?.id
						?? null;
					const rawUrl = fileItem?.url
						?? fileItem?.content
						?? fileItem?.file?.content
						?? null;
					const rawName = fileItem?.name
						?? fileItem?.file?.name
						?? null;

					let matchedMeta = null;
					if (rawId && metaById.has(String(rawId))) {
						matchedMeta = metaById.get(String(rawId));
					} else if (rawUrl && metaByUrl.has(rawUrl)) {
						matchedMeta = metaByUrl.get(rawUrl);
					} else if (rawName && metaByName.has(rawName)) {
						matchedMeta = metaByName.get(rawName);
					}

					const attachmentId = matchedMeta?.attachment_id
						?? matchedMeta?.attachmentId
						?? rawId
						?? null;
					const storagePath = matchedMeta?.storage_path
						?? matchedMeta?.storagePath
						?? fileItem?.storage_path
						?? fileItem?.storagePath
						?? rawUrl
						?? null;
					const fileUrl = matchedMeta?.url
						?? rawUrl
						?? '';
					const fileName = matchedMeta?.name
						?? rawName
						?? '';
					const fileType = matchedMeta?.type
						?? fileItem?.type
						?? fileItem?.file?.type
						?? '';

					return {
						attachment_id: attachmentId,
						name: fileName,
						type: fileType,
						url: fileUrl,
						storage_path: storagePath || null,
					};
				});
			}

			return {
				question_name: question.title,
				question_content: question.question_type ?? question.name,
				answer_content: answerContent,
				question_id: question.name
			};
		});

	    const data = {
	      form: {
	        survey: surveyData,
	        type: 'self_create',
	        signature_path: padRef.current && Object.keys(padRef.current).length === 0 && padRef.current.constructor === Object ? '' : padRef.current.toDataURL('image/png'),
			results: formattedResults
	      },
	    }

	    formService.storeOrUpdate(data, form.id).then(res => {
	      if(res.code === '0000'){
	        message.success('Submit success')
	        uploadedFilesRef.current = {};
	        setShowFinalScreen(true)
	      }else{
	        message.error(res.message)
	      }
	    });
	}

	const handleSubmit = (e) => {
	    setLoading(true);

	    pdfForm
	      .validateFields()
	      .then(values => {
	        setLoading(true);
	        onStore(values);
	      })
	      .catch(info => {
	        console.log('Validate Failed:', info);
	        setLoading(false);
	      });
	  }

	  const onStore = (values) => {
	    const data = {
	      form: {
	      	...values.form,
	        type: 'pdf_upload',
	        signature_path: padRef.current && Object.keys(padRef.current).length === 0 && padRef.current.constructor === Object ? '' : padRef.current.toDataURL('image/png')
	      }
	    }

	    formService.storeOrUpdate(data, form.id).then(res => {
	      if(res.code === '0000'){
	        message.success('Submit success')
	      	checkFormSubmission(token)
	        pdfForm.resetFields();
	        setLoading(false)
	        setShowFinalScreen(true)
	      }else{
	        message.error(res.message)
	        setLoading(false)
	      }
	    });
	  }

	// Schema-engine submit (in-app, forms carrying schema_json). Reuses the same
	// global_form store the in-app system_forms path already writes (handleFinish),
	// so no backend change is needed. Survey path untouched.
	// For a check-in schema form, prepend the "Check-in Info" step so the guest
	// fills Name/Phone/Email (+ Business for contractors) as step 1 of the stepper.
	const schemaForm = useMemo(() => withCheckinInfoStep(form), [form]);

	const handleSchemaSubmit = (answers) => {
	    setLoading(true);
	    // Lift the leading "Check-in Info" step (prepended for check-in forms) out of
	    // the schema answers into a checkin_info block.
	    const { globalForm, checkinInfo } = liftCheckinInfo(answers, form);
	    const data = {
	      form: {
	        global_form: globalForm,
	        type: form.type || 'self_create',
	        ...(checkinInfo ? { checkin_info: checkinInfo } : {}),
	      },
	    };
	    formService.storeOrUpdate(data, form.id).then(res => {
	      if (res.code === '0000') {
	        message.success('Submit success');
	        setShowFinalScreen(true);
	      } else {
	        message.error(res.message || 'Submission failed');
	      }
	      setLoading(false);
	    });
	}

	const handleClear = () => {
	    padRef.current.clear();
	}

	const handleSubmitGlobalForm = () => {
        setLoading(true);
        globalForm
          .validateFields()
          .then(values => {
            handleFinish(values);
          })
          .catch(info => {
            console.log('Validate Failed:', info);
            setLoading(false);
        });
    }

    const handleFinish = (values) => {
      const data = {
	      form: {
	        global_form: values,
	        type: 'system_forms'
	      }
	    }

	    formService.storeOrUpdate(data, form.id).then(res => {
	      if(res.code === '0000'){
	        message.success('Submit success')
	        setShowFinalScreen(true)
	      }else{
	        message.error(res.message)
	      }
	    });
    }
	
	const handleUploadFiles = async (_survey, options) => {
		try {
		  if (!options.files || options.files.length !== 1) {
			options.callback([], ["Exactly one file is required"]);
			return;
		  }
	  
		  const f = options.files[0];
	  
		  // Phân loại để gửi lên BE (không dùng cho preview)
		  let serverType = 'file';
		  if (f.type?.startsWith('image/')) serverType = 'image';
		  else if (f.type?.startsWith('video/')) serverType = 'video';
	  
		  const resp = await attachment.uploadFile(f, serverType);
		  const fileUrl = resp?.attachment?.full_path || resp?.attachment?.url || '';
		  const storagePath = resp?.attachment?.url || '';
		  const attachmentId = resp?.attachment?.id ?? null;
	  
		  if (!fileUrl) {
			options.callback([], ["Upload succeeded but no URL returned"]);
			return;
		  }
	  
		  const uploadedFile = {
			file: {
			  name: f.name,
			  type: f.type,
			  content: fileUrl
			},
			content: fileUrl,
			attachmentId,
			attachment_id: attachmentId,
			name: f.name,
			type: f.type,
			url: fileUrl,
			storagePath,
			storage_path: storagePath,
		  };

		  const questionName = options?.question?.name;
		  const allowMultiple = options?.question?.allowMultiple !== false;
		  if (questionName) {
			const existingMeta = allowMultiple
				? (uploadedFilesRef.current[questionName] || [])
				: [];
			const filteredMeta = existingMeta.filter(item => item?.attachment_id !== attachmentId);
			uploadedFilesRef.current[questionName] = allowMultiple
				? [...filteredMeta, {
					attachment_id: attachmentId,
					name: f.name,
					type: f.type,
					url: fileUrl,
					storage_path: storagePath,
				  }]
				: [{
					attachment_id: attachmentId,
					name: f.name,
					type: f.type,
					url: fileUrl,
					storage_path: storagePath,
				}];
		  }

		  options.callback("success", [uploadedFile]);

		} catch (err) {
		  console.error("Upload error:", err);
		  options.callback("error", err?.message || "Upload error");
		}
	  };

	const handleSurveyValueChanged = (_survey, options) => {
		if (options?.question?.question_type !== 'upload_file') {
			return;
		}

		const questionName = options?.question?.name;
		if (!questionName) {
			return;
		}

		const currentValue = Array.isArray(options?.value) ? options.value : [];
		if (currentValue.length === 0) {
			delete uploadedFilesRef.current[questionName];
			return;
		}

		const currentIds = new Set();
		const currentUrls = new Set();
		const currentNames = new Set();

		currentValue.forEach(item => {
			const id =
				item?.attachment_id
				?? item?.attachmentId
				?? null;
			if (id) {
				currentIds.add(String(id));
			}

			const url =
				item?.content
				?? item?.file?.content
				?? item?.url
				?? null;
			if (url) {
				currentUrls.add(url);
			}

			const name =
				item?.name
				?? item?.file?.name
				?? null;
			if (name) {
				currentNames.add(name);
			}
		});

		const existingMeta = uploadedFilesRef.current[questionName] || [];
		const filteredMeta = existingMeta.filter(metaItem => {
			const metaId =
				metaItem?.attachment_id
				?? metaItem?.attachmentId
				?? null;
			if (metaId && currentIds.has(String(metaId))) {
				return true;
			}

			const metaUrl =
				metaItem?.url
				?? metaItem?.storage_path
				?? null;
			if (metaUrl && currentUrls.has(metaUrl)) {
				return true;
			}

			const metaName = metaItem?.name ?? null;
			if (metaName && currentNames.has(metaName)) {
				return true;
			}

			return false;
		});

		if (filteredMeta.length > 0) {
			uploadedFilesRef.current[questionName] = filteredMeta;
		} else {
			delete uploadedFilesRef.current[questionName];
		}
	};

  return (
	
    <LayoutWrapper>
      <FormPage>
        {errorMsg && errorMsg !== '' && !showFinalScreen &&
            <Alert message={errorMsg} type="error" />
        }
        {/* Schema engine (Phase 5): schema_json present -> new renderer; else the
            untouched survey/type paths below (all guarded by !schema_json). */}
        {
        	form && form.schema_json && !showFinalScreen &&
        	<SchemaFormRenderer
        		form={schemaForm}
        		hosts={form && (form.hosts || (form.property && form.property.hosts))}
        		loading={loading}
        		onSubmit={handleSchemaSubmit}
        	/>
        }
        {
        	form && !form.schema_json && form.type == 'self_create' && !showFinalScreen && surveyContent && Array.isArray(surveyContent.pages) && surveyContent.pages.length > 0 && <Survey.Survey json={surveyContent} onComplete={submitSurveyData} onUploadFiles={handleUploadFiles} onValueChanged={handleSurveyValueChanged}/>
        }
        {
        	/* A self_create survey with no questions would render an empty SurveyJS model
        	   (which can crash) — show the survey header + a note instead of a blank page. */
        	form && !form.schema_json && form.type == 'self_create' && !showFinalScreen && surveyContent && Array.isArray(surveyContent.pages) && surveyContent.pages.length === 0 &&
        	<Card style={{ margin: 20 }}>
        		<h2>{form.survey_title || form.name}</h2>
        		{form.survey_description && <p>{form.survey_description}</p>}
        		<p style={{ color: '#888' }}>This form has no questions to display.</p>
        	</Card>
        }
        { showFinalScreen && <FinalScreen /> }
        {
        	form && !form.schema_json && form.type == 'pdf_upload' && !showFinalScreen &&
        	<Row>
        		<Col xs={{span: 24}} md={{span: 12}}>
        			<iframe src={(form.files && form.files.length) ? process.env.REACT_APP_API_BASE_URL + form.files[form.files.length-1].path : ''} />
        		</Col>
        		<Col xs={{span: 24}} md={{span: 11, offset: 1}}>
        			<Form
				        layout="vertical"
				        scrollToFirstError
				        className="form-body"
				        form={pdfForm}
				    >
				    	<Form.Item
			                name={['form', 'is_agree']}
			                className="isoInputWrapper"
			                valuePropName="checked"
			            >
			                <Checkbox>{<IntlMessages id="formPage.modal.agreeConfirm" />}</Checkbox>
			                
			            </Form.Item>
			            <h3>{<IntlMessages id="formPage.modal.signature" />}</h3>
			        	<div className="signature-area">
			                <SignatureCanvas ref={padRef} />
			                <button onClick={handleClear} className="signature-clear-button">Clear</button>
			            </div>
			            <div className="isoInputWrapper">
				            <Button key="submit" className="btn-success" type="primary" loading={loading} onClick={handleSubmit}>
					          {<IntlMessages id="propertyPage.modal.save" />}
					        </Button>
					    </div>
		           	</Form>
        		</Col>
        	</Row>
        }
        {
        	form && !form.schema_json && form.type == 'system_forms' && !showFinalScreen &&
        	<GlobalForm formData={form} setShowFinalScreen={setShowFinalScreen}/>
        }
		{
        	form && !form.schema_json && form.type == 'bio_form' && !showFinalScreen &&
        	<BioForm formData={form} setShowFinalScreen={setShowFinalScreen} isAbleToSubmit={true}/>
        }
		{
        	form && !form.schema_json && form.type == 'checkin_form' && !showFinalScreen &&
        	<CheckinForm formData={form} setShowFinalScreen={setShowFinalScreen} isAbleToSubmit={true}/>
        }
		{
        	form && !form.schema_json && form.type == 'hazard_form' && !showFinalScreen &&
        	<HazardForm formData={form} propertyId={form.property_id} setShowFinalScreen={setShowFinalScreen} isAbleToSubmit={true}/>
        }
		{
        	form && !form.schema_json && form.type == 'training_form' && !showFinalScreen &&
        	<TrainingForm formData={form} propertyId={form.property_id} setShowFinalScreen={setShowFinalScreen} isAbleToSubmit={true}/>
        }
		{
        	form && !form.schema_json && form.type == 'illness_form' && !showFinalScreen &&
        	<IllnessForm formData={form} propertyId={form.property_id} setShowFinalScreen={setShowFinalScreen} isAbleToSubmit={true}/>
        }
		{
        	form && !form.schema_json && form.type == 'near_miss_form' && !showFinalScreen &&
        	<NearMissForm formData={form} propertyId={form.property_id} setShowFinalScreen={setShowFinalScreen} isAbleToSubmit={true}/>
        }

      </FormPage>
    </LayoutWrapper>
  );
}

export default FormSubmission;
